export const enCarLogTranslations = {
  carLog: {
    actions: {
      export: 'Export walks to excel',
      clear: 'Clear selection',
    },
    filters: {
      activity: 'Activity',
      tags: 'Tags',
    },
    row: {
      actions: {
        delete: {
          dialog: {
            discard: 'Discard',
            body: 'This action cannot be undone. Deleting this',
            subBody:
              'may affect any function related to motion measurement in the system, including billing reports.',
            subText:
              'Reports that were generated based on this data will not be alerted retrospectively. Make sure to review and change them in your EMR record if needed.',
          },
        },
      },
      labels: {
        minimal: 'Minimal analysis',
        partial: 'Partial analysis',
        manual: 'Manually reported',
      },
      activityName: {
        adjustment: 'Adjustment',
        registered: 'Registered on Onestep',
        sessionEnd: 'Finished exercise session',
        courseStart: 'Started exercise course',
        courseEnd: 'Finished exercise course',
        cycleEnd: 'Active days cycle ended',
        cycleStart: 'Active days cycle started',
        startedEpisodeOfCare: 'Started episode of care',
        endEpisodeOfCare: 'Ended episode of care',
        discharge: 'Discharged',
        rtmCountStart: 'RTM count started',
        monitorEvent: 'Monitoring event',
        progressNoteGenerated: 'Patient note generated',
      },
      questionName: {
        amppro: 'AMPPRO',
        vas: 'Pain Rating',
        quick_dash: 'QuickDASH Questionnaire',
        fabq: 'FABQ Questionnaire',
        lefs: 'Lower Extremity Functional Scale Questionnaire',
        ndi: 'NDI Questionnaire',
        fes: 'Falls Efficacy Scale Questionnaire',
        fall_confidence: 'Fear of Falls',
        fear_of_falls: 'Fear of Falls',
        psfs: 'PSFS',
        create_psfs: 'PSFS',
        pain_function_limitation: 'Pain function limitation',
        sf_36: 'SF 36',
      },
      measurementName: {
        dual_task_walk_subtract: 'Dual Task Walk',
      },
      measurementTag: {
        dual_task_walk_subtract: 'Dual task',
      },
      field: {
        fall: {
          description: 'Description',
          witnessed: 'Witnessed',
          location: 'Location',
          witnessedOptions: {
            yes: 'Yes',
            no: 'No',
          },
        },
        injury: {
          side: 'Side',
        },
        questionnaire: {
          questionID: 'Question ID',
          answerID: 'Answer ID',
          question: 'Question',
          answer: 'Answer',
          other: 'Other',
          intensity: 'Level of intensity (1 - 10)',
          symptoms: 'Symptoms',
          comment: 'Comment',
        },
        walk: {
          duration: 'Duration',
          notes: 'Notes',
          tags: 'Tags',
        },
        recordedSide: 'Recorded side',
        score: 'Score',
      },
    },
    compare: {
      labels: {
        onlyOneActivityType: `Only one measurement of this type is available. Record another measurement to enable comparison, or adjust the time filter to include more data.`,
        compareTwoActivities: 'Select two activities to compare between',
        oneMoreActivity: 'Select one more activity',
        deselectActivity: 'Activities selected, deselect in order to change',
      },
    },
    emptyState: {
      label: 'There are no recorded activities of this type',
    },
  },
};
